import { api } from "../index";
import { PaginatedResponse } from "../types";
import { toFrontStatus, toBackendStatus } from "./status";

export interface CollaborationImage {
  imagem_id: number;
  url_imagem: string;
  codigo_imagem: string;
  status?: string; // front mapped
  estado?: string; // backend inconsistência
  descricao?: string;
}

export async function listImagesByCollaboration(
  colaboracaoId: number,
  token?: string,
  page: number = 1,
  pageSize: number = 20
): Promise<PaginatedResponse<CollaborationImage>> {
  const headers = token ? { "X-CSRF-Token": token } : undefined;
  try {
    const r = await api.get(
      `/imagens/colaboracao/${colaboracaoId}`,
      {
        params: { page, pageSize },
        headers,
      }
    );
    const data = r.data as PaginatedResponse<CollaborationImage>;
    return {
      ...data,
      items: data.items.map((img: any) => ({
        ...img,
        status: toFrontStatus(img.status || img.estado),
      })),
    };
  } catch (e) {
    // Falha silenciosa (ex: endpoint requer auth quando usuário público). Retorna vazio.
    return {
      items: [],
      total: 0,
      page: 1,
      pageSize: 20,
      totalPages: 0,
    };
  }
}

export async function updateImageStatus(
  imagemId: number,
  newFrontStatus: string,
  token: string
) {
  const status = toBackendStatus(newFrontStatus);
  const r = await api.put(
    `/imagens/status/${imagemId}`,
    { status },
    { headers: { "X-CSRF-Token": token } }
  );
  const img = r.data;
  return { ...img, status: toFrontStatus(img.status || img.estado) };
}
